import SCAcademy from "assets/sc-academy.svg";
import SCAdhere from "assets/sc-adhere-new.svg";
import SCSecure from "assets/sc-secure.svg";
import ScOculus from "assets/sc-oculus.svg";
import SCTrust from "assets/sc-trust.svg";
import smart_comply_logo_blue from "assets/smartcomply-blue.svg";
import { useGetStartedContext } from "context/GetStartedContextProvider";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import MobileNavbar from "./MobileNavbar";
import LanguageSwitcher from "./sections/home/LanguageSwitcher";
import Button from "./Button";
// import Banner from "./Banner";

const Navbar = () => {
  const pathname = useLocation().pathname;
  const { t } = useTranslation("home");
  const { handleModalChange } = useGetStartedContext();
  const scrollTargetRef = useRef(null);

  const handleHover = () => {
    if (scrollTargetRef.current) {
      scrollTargetRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  // mt-0 h-[85px] max-md:h-[70px] flex flex-row items-center justify-between py-4 gap-6 px-14 max-md:p-8 max-[520px]:px-4 max-md:py-6
  return (
    <div className="z-[1000] fixed w-full top-0 text-lexend">
      {/* <Banner /> */}
      <nav className="relative h-[85px] max-md:h-[70px] md:flex-row md:justify-between xl:justify-left flex items-center px-14 max-md:px-8 max-[520px]:px-4 bg-white">
        {/* Logo (Left) */}
        <Link to="/">
          <img
            src={smart_comply_logo_blue}
            alt="Smartcomply"
            className="w-32 max-md:w-28 max-[520px]:w-24"
          />
        </Link>
        {/* hidden md:flex flex-row justify-center items-center gap-10 max-lg:gap-5 text-[#00000066] text-sm */}
        {/* Center Menu */}
        <div className="hidden lg:flex absolute md:left-[40%] xl:left-1/2 -translate-x-1/2 justify-center items-center gap-10 max-lg:gap-5 text-[#00000066] text-sm">
          <Link to="/" className="capitalize">
            {t("navlinks.home")}
          </Link>

          {/* Products Dropdown */}
          <div className="relative z-40 group">
            <button
              onMouseEnter={handleHover}
              className="flex items-center gap-2 capitalize"
            >
              {t("navlinks.products.title")}
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path
                  d="M0.8 0.8L4.8 4.8L8.8 0.8"
                  stroke="black"
                  strokeOpacity="0.4"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <div className="absolute left-0 mt-4 scale-0 group-hover:scale-100 transition duration-150 origin-top">
              <div
                ref={scrollTargetRef}
                className="rounded-lg max-h-[400px] overflow-y-auto w-[340px] p-8 space-y-3 bg-white border shadow-[0px_4px_55px_5px_#12121226]"
              >
                {/* Seequre */}
                <ProductItem
                  img={SCSecure}
                  title="Seequre"
                  description={t("navlinks.products.secure")}
                  link="https://secure.smartcomply.com"
                />

                {/* Adhere */}
                <ProductItem
                  img={SCAdhere}
                  title="Adhere"
                  description={t("navlinks.products.adhere")}
                  link="https://adhere.smartcomply.com/"
                />

                {/* Oculus */}
                <ProductItem
                  img={ScOculus}
                  title="Oculus"
                  description={t("navlinks.products.intel")}
                  link="https://intel.smartcomply.com/"
                />

                {/* Academy */}
                <ProductItem
                  img={SCAcademy}
                  title="Smartcomply Academy"
                  description={t("navlinks.products.academy")}
                  link="https://academy.smartcomply.com/"
                />

                {/* Trust */}
                <div className="p-4 border border-[#F1F1F1] hover:border-[#F4C5E6] hover:bg-[#FFE5F7B2] rounded-lg">
                  <div className="flex space-x-3">
                    <img src={SCTrust} className="w-7 h-7" alt="trust" />
                    <div>
                      <h4 className="font-semibold text-[15px] text-black mb-2">
                        Smartcomply Trust
                      </h4>
                      <p className="text-[#EF5025] text-[14px] uppercase">
                        {t("navlinks.comingSoon")}!!!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Link to="/about-us" className="capitalize">
            {t("navlinks.about")}
          </Link>

          <Link to="/blog" className="capitalize">
            {t("blog.title")}
          </Link>
        </div>

        {/* Right Section */}
        <div className="ml-auto hidden md:flex items-center gap-4">
          <Button
            type="button"
            variant="outlined"
            text="Book a demo"
            className="!px-6"
            onClick={() => handleModalChange(true)}
          />
          <LanguageSwitcher />
        </div>

        {/* Mobile */}
        <div className="ml-auto block lg:hidden">
          <MobileNavbar pathname={pathname} />
        </div>
      </nav>
    </div>
  );
};

/* Reusable Product Item Component */
const ProductItem = ({ img, title, description, link }) => (
  <div className="p-4 border border-[#F1F1F1] hover:border-[#F4C5E6] hover:bg-[#FFE5F7B2] rounded-lg">
    <Link target="_blank" to={link} className="flex space-x-3">
      <img src={img} className="w-7 h-7 flex-shrink-0" alt={title} />
      <div>
        <h4 className="font-semibold text-[15px] text-black mb-2">{title}</h4>
        <p className="text-[#6F6F6F] text-[14px]">{description}</p>
      </div>
    </Link>
  </div>
);

export default Navbar;
